import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Cell } from 'sarsaparilla';
import { PassTypeProps } from '../props';
import { SimpleGuestCounter } from '../../../ui-lottery/src/components/inputs';

const propTypes = {
  attendeeInfo: PropTypes.objectOf(PropTypes.number).isRequired,
  passType: PassTypeProps.isRequired,
  onChange: PropTypes.func.isRequired
};

export default class AttendeeInfoForm extends PureComponent {
  constructor(props) {
    super(props);

    this.onCountsChanged = this.onCountsChanged.bind(this);
  }

  componentDidMount() {
    this.props.onChange(this.props.attendeeInfo, true);
  }

  componentWillUnmount() {
    this.props.onChange(this.props.attendeeInfo, true);
  }

  onCountsChanged(value) {
    const { passType } = this.props;
    const counts = {};

    for (const key of Object.keys(value)) {
      const { attendee_min: min, attendee_max: max } = passType.groups[key];

      counts[key] = Math.max(min, value[key]);
      if (max !== 0) {
        counts[key] = Math.min(max, counts[key]);
      }
    }

    this.props.onChange(counts, true);
  }

  render() {
    const { passType, attendeeInfo } = this.props;

    if (passType.features.indexOf('attendee-info') === -1) {
      return null;
    }

    const groups = Object.entries(passType.groups).map(([key, group]) => ({
      key,
      type: group.name,
      description: group.description
    }));

    const counts = {};
    for (const key of Object.keys(passType.groups)) {
      counts[key] = attendeeInfo[key] || passType.groups[key].attendee_min;
    }

    return (
      <Row>
        <Cell>
          <SimpleGuestCounter
            id={'attendee-group-counts'}
            groups={groups}
            counts={counts}
            label={'Attendees'}
            title={'Attendees'}
            onChange={this.onCountsChanged} />
        </Cell>
      </Row>
    );
  }
}

AttendeeInfoForm.propTypes = propTypes;
